import { Link } from "react-router-dom";
import { Linkedin, Youtube } from "lucide-react";

const Footer = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground text-background py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold mb-6">Navigation</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/programm" className="text-background/70 hover:text-background transition-colors">
                  Das Programm
                </Link>
              </li>
              <li>
                <Link to="/warum-maip" className="text-background/70 hover:text-background transition-colors">
                  Warum MAIP?
                </Link>
              </li>
              <li>
                <Link to="/experten" className="text-background/70 hover:text-background transition-colors">
                  Dozierende
                </Link>
              </li>
              <li>
                <Link to="/wissen" className="text-background/70 hover:text-background transition-colors">
                  Wissen & Praxis
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-background/70 hover:text-background transition-colors">
                  Kontakt
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-background/70 hover:text-background transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-6">Wissen & Ressourcen</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/glossar" className="text-background/70 hover:text-background transition-colors">
                  KI-Glossar
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-background/70 hover:text-background transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/downloads/glossar" className="text-background/70 hover:text-background transition-colors">
                  Glossar als PDF
                </Link>
              </li>
              <li>
                <Link to="/downloads/checkliste" className="text-background/70 hover:text-background transition-colors">
                  Checklisten
                </Link>
              </li>
              <li>
                <Link to="/downloads/arbeitsblatt" className="text-background/70 hover:text-background transition-colors">
                  Arbeitsblätter
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-6">Service & Rechtliches</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/buchung-verwalten" className="text-background/70 hover:text-background transition-colors">
                  Buchung verwalten
                </Link>
              </li>
              <li>
                <Link to="/impressum" className="text-background/70 hover:text-background transition-colors">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="text-background/70 hover:text-background transition-colors">
                  Datenschutz
                </Link>
              </li>
              <li>
                <Link to="/agb" className="text-background/70 hover:text-background transition-colors">
                  AGB
                </Link>
              </li>
              <li>
                <Link to="/nutzungsbedingungen" className="text-background/70 hover:text-background transition-colors">
                  Nutzungsbedingungen
                </Link>
              </li>
              <li>
                <Link to="/widerruf" className="text-background/70 hover:text-background transition-colors">
                  Widerrufsbelehrung
                </Link>
              </li>
              <li>
                <Link to="/barrierefreiheit" className="text-background/70 hover:text-background transition-colors">
                  Barrierefreiheit
                </Link>
              </li>
              <li>
                <Link to="/voraussetzungen" className="text-background/70 hover:text-background transition-colors">
                  Technische Voraussetzungen
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-6">Folgen Sie uns</h3>
            <div className="flex space-x-4">
              <a 
                href="https://www.linkedin.com/company/maip-info" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-background/70 hover:text-background transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-6 h-6" />
              </a>
              <a 
                href="https://www.youtube.com/@maip-info" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-background/70 hover:text-background transition-colors"
                aria-label="YouTube"
              >
                <Youtube className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-background/20 mt-12 pt-8 text-center">
          <p className="text-background/60">© 2025 MAIP.info - Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
